import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import { WeeklySummaryRun } from "./types";

export async function getWeeklySummaryRuns(limit = 12): Promise<WeeklySummaryRun[]> {
    try {
        const headers = await getAuthHeader();
        const response = await axios.get<WeeklySummaryRun[]>(
            `${process.env.REACT_APP_BACKEND_URL}/admin/weekly-summary/runs`,
            { headers, params: { limit } }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching weekly summary runs:", error);
        throw new Error("Error fetching weekly summary runs");
    }
}
